import { v4 } from 'uuid';
/**
 * Generic utility for handling embed message requests and responses
 * Used by both product and order data fetching functions
 */
export const createEmbedMessageHandler = (options) => {
    const { type, payload, timeout = 10000, } = options;
    const messageKey = v4();
    return new Promise((resolve, reject) => {
        const message = {
            source: 'microcommerce-ai-embed',
            type,
            messageKey,
            payload,
        };
        // console.log('[EmbedMessageHandler] Sending postMessage:', message);
        window.parent.postMessage(message, '*');
        let timeoutId;
        const handleResponse = (event) => {
            const eventData = event.data;
            // Check if this is the response we're waiting for
            if (eventData.source !== 'microcommerce-ai-embed') {
                return;
            }
            // console.log('[EmbedMessageHandler] Received message event:', event.data);
            // Check if this response is for our specific request
            if (eventData.messageKey !== messageKey) {
                return;
            }
            // Clean up listener and timeout
            window.removeEventListener('message', handleResponse);
            clearTimeout(timeoutId);
            const responsePayload = eventData.payload;
            resolve(responsePayload);
        };
        // Set up timeout
        timeoutId = setTimeout(() => {
            window.removeEventListener('message', handleResponse);
            reject(new Error(`${type} request timed out`));
        }, timeout);
        // console.log('[EmbedMessageHandler] Setting up message listener for', messageKey);
        window.addEventListener('message', handleResponse);
    });
};
//# sourceMappingURL=embedMessageHandler.js.map